<template>
	<div class="timeClock">
		<span class="hour numFont">{{hour}}</span>
		<span class="day numFont">{{day}}</span>
		<span class="week">{{week}}</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			hour: null,
			day: null,
			week: null,
		}
	},
	methods: {
		initTime() {
			let weeks = {
				"0": "日",
				"1": "一",
				"2": "二",
				"3": "三",
				"4": "四",
				"5": "五",
				"6": "六",
			};
			function repair(num) {
				return num.toString().padStart(2, 0)
			}
			let nowTime = new Date();
			let year = nowTime.getFullYear();
			let month = repair(nowTime.getMonth() + 1);
			let day = repair(nowTime.getDate());
			let hour = repair(nowTime.getHours());
			let min = repair(nowTime.getMinutes());
			let second = repair(nowTime.getSeconds());
			let week = weeks[nowTime.getDay()];
			this.hour = `${hour}:${min}:${second}`;
			this.day = `${year}.${month}.${day}`;
			this.week = `星期${week}`;
		}
	},
	created() {
		this.initTime();
		let timer = setInterval(() => {
			this.initTime();
		}, 1000);
		this.$once('hook:beforeDestory', () => {
			clearInterval(timer);
			timer = null;
		})
	}
}
</script>


<style lang="scss" scoped>
.timeClock {
	height: 100px;
	background: url('../assets/timeClock.png') no-repeat;
	background-size: 100% 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #00bcff;
	.hour {
		font-size: 26px;
		margin-right: 15px;
	}
	.day {
		font-size: 18px;
		margin-right: 15px;
	}
	.week {
		font-size: 14px;
	}
}
</style>